<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="jumbotron jumbotron-fluid">
      <div class="d-flex flex-wrap">
        <div>
          <h2 class="display-4">Revenue Appeals Tribunal e-Library</h2>
          <p class="lead">Welcome to the e-Library, your one-stop-shop for tax dispute resources: Discover, learn and stay updated with E-library</p>
        </div>
      </div>

      <h3>Resources:</h3>
      <ul>
        <li><b>Judgements:</b> formal decisions made by court of law or tax tribunal.</li>
        <li><b>Legislation:</b> Laws and regulations created by government or legislation body.</li>
        <li><b>eBooks:</b> Digital versions of printed books.</li>
        <li><b>Online databases:</b> Digital collections of scholarly research materials i.e. research articles, conference proceedings.</li>
        <li><b>Website & Portals:</b> Online platforms providing access to decisions from other tax tribunals and tax related bodies/orgs.</li>
      </ul>
      <div *ngIf="isLoggedIn; else notLoggedIn">
        <h3>Exclusive Resources:</h3>
        <p>Get access to some exclusive library resources provided by our partners:
          <ol>
            <li>Tribunal judgements: <a href="https://tat.gov.ng/judgement/" target="_blank">Nigeria</a>, <a href="https://tat.go.ug/tat-appealed-decisions/" target="_blank">Uganda</a>, <a href="http://kenyalaw.org/kl/index.php?id=8380" target="_blank">Kenya</a></li>
            <li>Malawi Legal Information Institute: <a href="https://malawilii.org/" target="_blank">MalawiLii</a></li>
            <li>Research for Life: <a href="https://www.research4life.org/" target="_blank">Research for Life</a></li>
            <li>International Centre for Tax and Development (ICTD): <a href="https://www.ictd.ac/" target="_blank">ICTD</a></li>
            <li>African Tax Administration Forum (ATAF): <a href="https://www.ataftax.org/" target="_blank">ATAF</a></li>
          </ol>
      </div>
      <ng-template #notLoggedIn>
        <h3>Get Started:</h3>
        <p>Log in and explore the e-library. Let it be your tax research partner.</p>
      </ng-template>
    </div>
  </div>
  <picture class="background-image">
    <!--source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1200w, assets/dspace/images/banner-tall.webp 768w"-->
    <source type="image/jpg" srcset="assets/dspace/images/library-small.jpg 2000w, assets/dspace/images/library-small.jpg 1200w, assets/dspace/images/library-small.jpg 768w">
    <img alt="" [src]="'assets/dspace/images/library-small.jpg'"/><!-- without the []="''" Firefox downloads both the fallback and the resolved image -->
  </picture>
  <small class="credits">Source: <a href="https://www.pexels.com">Pexels.com</a></small>
</div>
